/* @jsx h */
import { defineComponent, h } from "vue";
import { DateRangePicker, DateRange, ListMultiSelect } from "@lemmonhq/uikit";
import { useAuth } from "@app/vue/providers/Auth";

import { useLocalization } from "@lemmonhq/uikit";

export interface OverviewFiltersProps {
  filters: {
    dateRange: DateRange;
    activeShiftOnly: boolean;
    userIds: number[];
  };
  users: { id: number; name: string }[];
  onFiltersChange: (filters: OverviewFiltersProps["filters"]) => void;
}

export const OverviewFilters = defineComponent<OverviewFiltersProps>({
  name: "OverviewFilters",
  props: ["filters", "users", "onFiltersChange"],
  setup(props) {
    const auth = useAuth();
    const { t } = useLocalization();
    return () => (
      <div class="flex items-center gap-2 sm:gap-4">
        <div>
          <label class="form-control">
            <DateRangePicker
              className="[&>button]:btn-sm sm:[&>button]:btn-md"
              value={props.filters.dateRange}
              disabled={
                props.filters.activeShiftOnly ||
                auth.user.value?.role === "staff"
              }
              onChange={(dateRange) =>
                props.onFiltersChange({
                  ...props.filters,
                  dateRange,
                  activeShiftOnly: false,
                })
              }
            />
          </label>
        </div>
        {auth.user.value?.role !== "staff" ? (
          <div>
            <ListMultiSelect
              items={props.users}
              selectedIds={props.filters.userIds}
              compact={true}
              widthClass="w-auto"
              buttonLabel={t("reports.overview.user_filter_label")}
              searchPlaceholder={t("reports.overview.user_filter_search")}
              onChange={(userIds) =>
                props.onFiltersChange({
                  ...props.filters,
                  userIds,
                })
              }
            />
          </div>
        ) : null}
      </div>
    );
  },
});
